import axios from "axios";
import {apiUrl} from "../../api/common";
import {HomeImages} from "../../types/homeImages/homeImages";

export class HomeImagesHandler {

    public static getHomeImages() : Promise<Array<HomeImages>> {
        return new Promise<Array<HomeImages>> (function (resolve, reject) {
            axios.get(apiUrl + '/homeImages' ,{}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }
}
